import VueSelect from 'vue-select';
import PhoneNumber from './DNFORM-phone-number/DNFORM-phone-number.vue';
import InputEmail from './DNFORM-input-email/DNFORM-input-email.vue';
import {fileInputMixin} from './DNFORM-mixins/DNFORM-file-input-mixin';
import {formSubmitMixin} from './DNFORM-mixins/DNFORM-form-submit-mixin';
import {responseHandlerMixin} from './DNFORM-mixins/DNFORM-response-handler-mixin';
import {sessionMixin} from './DNFORM-mixins/DNFORM-session-mixin';
import {stepperMixin} from './DNFORM-mixins/DNFORM-stepper-mixin';
import {summaryMixin} from './DNFORM-mixins/DNFORM-summary-mixin';
import {validationMixin} from './DNFORM-mixins/DNFORM-validation-mixin';
import {initRecaptcha} from '../../common/recaptcha-v3/init-recaptcha-v3';
import {PHONE_NUMBER_INPUT_FIELDS} from './DNFORM-utils/DNFORM-constants';

export default {
	name: 'Dynaform',
	components: {
		'vue-select': VueSelect,
		'phone-number': PhoneNumber,
		'input-email': InputEmail
	},
	props: {
		formId: {
			type: String,
			required: true
		},
		formModel: {
			type: Object,
			required: true
		},
		formValidation: {
			type: Object,
			required: true
		},
		labelsOfInputs: {
			type: Object,
			required: false,
			default: undefined
		},
		isRecaptchaEnabled: {
			type: Boolean,
			required: false,
			default: false
		},
		isSummaryEnabled: {
			type: Boolean,
			required: false,
			default: false
		},
		steps: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	data() {
		return {
			PHONE_NUMBER_INPUT_FIELDS,
			fromId: this.formId,
			model: {},
			modelForSummary: {},
			validation: {}
		};
	},
	mixins: [fileInputMixin, formSubmitMixin, responseHandlerMixin, sessionMixin, stepperMixin, summaryMixin, validationMixin],
	created() {
		this.model = JSON.parse(JSON.stringify(this.formModel));
		this.validation = JSON.parse(JSON.stringify(this.formValidation));
		this.extendValidation(this.validation, true);
	},
	mounted() {
		initRecaptcha();
		window.addEventListener('beforeunload', (event) => {
			if (this.warnOnPageLeave) {
				event.preventDefault();
				event.returnValue = '';
			}
		});
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM.js